import { Controller } from "@hotwired/stimulus"

// Drives the multi-session weekend row's split click target. Clicking the
// chevron toggles open/closed without selecting; clicking the row body is
// a normal Turbo Frame link to the weekend (handled by event-select).
//
// Selecting a weekend or one of its children also opens the group —
// event-select calls expand() on the closest group ancestor of the active
// card. One-way: chevron is the only way to re-collapse.
export default class extends Controller {
  static targets = ["chevron", "children"]
  static values = { open: { type: Boolean, default: false } }

  toggle(event) {
    // The chevron now lives inside the body <a>; without preventDefault
    // a click would bubble through stopPropagation's window and trigger
    // the link's navigate. Space-key default also scrolls the page —
    // suppress it here for keyboard activations.
    event.preventDefault()
    event.stopPropagation()
    this.openValue = !this.openValue
  }

  expand() {
    if (!this.openValue) this.openValue = true
  }

  openValueChanged() {
    if (this.hasChildrenTarget) {
      this.childrenTarget.classList.toggle("hidden", !this.openValue)
    }
    if (this.hasChevronTarget) {
      this.chevronTarget.setAttribute("aria-expanded", String(this.openValue))
      const svg = this.chevronTarget.querySelector("svg")
      if (svg) svg.classList.toggle("rotate-90", this.openValue)
    }
  }
}
